import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from 'src/redux/store';

import { Spinner } from './components/Spinner';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AbilityContext, defaultValue } from './utility/auth/acl/Can';

import { createTheme, ThemeProvider } from '@material-ui/core';
import '@assets/css/material-dashboard-pro-react.css';
import { infoColor } from '@assets/jss/material-dashboard-pro-react';

import { MsalProvider } from '@azure/msal-react';
import msalInstance from 'src/utility/msal';

// Pickers
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

const LazyApp = lazy(() => import('./App'));

const materialTheme = createTheme({
  palette: {
    primary: { main: infoColor[0], contrastText: '#FFF' }
  },
});

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <MsalProvider instance={msalInstance}>
        <AbilityContext.Provider value={defaultValue}>
          <ThemeProvider theme={materialTheme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <LazyApp />
              <ToastContainer newestOnTop limit={5} />
            </MuiPickersUtilsProvider>
          </ThemeProvider>
        </AbilityContext.Provider>
      </MsalProvider>
    </Suspense>
  </Provider >,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();